<template>
    <div class="switches">
        <div class="switches__switch">
            <div class="switches__title">{{ store.translations.MeasurementTitle }}</div>
            <div class="switches__buttons">
                <div
                    class="switches__button" :class="{ active: store.metric }"
                    role="button"
                    @click="store.setMetricActive"
                >
                    <div class="switches__button-text">
                        {{ store.translations.Metric }}
                    </div>
                </div>
              
                <div
                    class="switches__button" :class="{ active: !store.metric }"
                    role="button"
                    @click="store.setImperialActive"
                >
                    <div class="switches__button-text">{{ store.translations.Imperial }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useSeedRateCalculatorStore} from '../store/store.js';

const store = useSeedRateCalculatorStore();

</script>
